import { render } from "./Imago.vue?vue&type=template&id=31605230&scoped=true"
import script from "./Imago.vue?vue&type=script&lang=js"
export * from "./Imago.vue?vue&type=script&lang=js"

import "./Imago.vue?vue&type=style&index=0&id=31605230&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31605230"]])

export default __exports__